module.exports = __webpack_public_path__ + "img/icon_code.819c799a.png";